import * as React from "react";

function Refresh(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.width ?? 24}
      viewBox={`0 0 ${props.width ?? 24} ${props.width ?? 24}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15.375L8.60001 23.875L17.2 15.375L13.975 12.1875L10.75 15.375C10.75 14.2645 10.9224 13.1937 11.2421 12.1875C12.612 7.87682 16.6865 4.75 21.5 4.75C23.3628 4.75 25.115 5.2183 26.6425 6.04229L29.7738 2.94748C27.3998 1.40041 24.5563 0.5 21.5 0.5C14.2951 0.5 8.27269 5.50399 6.79635 12.1875C6.56952 13.2144 6.45001 14.2809 6.45001 15.375L3.225 12.1875L0 15.375Z"
        fill="#FEFEFE"
      />
      <path
        d="M13.2262 32.0525L16.3575 28.9577C17.885 29.7817 19.6372 30.25 21.5 30.25C26.3135 30.25 30.388 27.1232 31.7579 22.8125C32.0776 21.8063 32.25 20.7355 32.25 19.625L29.025 22.8125L25.8 19.625L34.4 11.125L43 19.625L39.775 22.8125L36.55 19.625C36.55 20.7191 36.4305 21.7856 36.2036 22.8125C34.7273 29.496 28.7049 34.5 21.5 34.5C18.4437 34.5 15.6002 33.5996 13.2262 32.0525Z"
        fill="#FEFEFE"
      />
    </svg>
  );
}

export default Refresh;
